module.exports = __webpack_public_path__ + "04_short_black.a3efa8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_short_black.png
// module id = iPf+
// module chunks = 0